import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Alert, Button, Image } from 'antd';
import { ArrowLeftOutlined, ArrowRightOutlined, PhoneOutlined } from '@ant-design/icons';
import '../styles/pharmacy-tool.css';

const GREEN = '#005537';

// Trang hướng dẫn dạng tài liệu của một skill/plugin, đọc từ `tool.guide` (file nội dung trong data/).
// Mở công khai (không cần đăng nhập) — nội dung là cách cài và dùng; file tải về vẫn khóa theo gói ở trang công cụ.
// VideoBatchToolPage tự mở trang này ở tab mới khi khách bấm tải (T.guidePath).
export function SkillGuidePage({ tool: T }) {
  const G = T.guide;

  const quoteBox = (text) => (
    <div
      style={{
        whiteSpace: 'pre-line',
        background: '#f0fdf4',
        border: '1px solid #bbf7d0',
        borderRadius: 8,
        padding: '10px 14px',
        margin: '8px 0',
        color: '#14532d',
        fontSize: 14.5,
        lineHeight: 1.6,
      }}
    >
      {text}
    </div>
  );

  const textStyle = { color: '#334155', fontSize: 15, lineHeight: 1.7, margin: '0 0 8px' };

  return (
    <div style={{ background: '#f8fafc', minHeight: '100vh', padding: '24px 16px 48px' }}>
      <div style={{ maxWidth: 860, margin: '0 auto' }}>
        <Link to={`/tools/${T.slug}`} style={{ color: GREEN, fontWeight: 600 }}>
          <ArrowLeftOutlined /> {T.name}
        </Link>

        <div style={{ background: GREEN, color: '#fff', borderRadius: 16, padding: '24px 24px 20px', margin: '14px 0 20px' }}>
          <h1 style={{ color: '#fff', fontSize: 26, fontWeight: 800, margin: 0 }}>{G.title}</h1>
          <div style={{ color: '#a7f3d0', fontSize: 16, fontWeight: 600, marginTop: 4 }}>{G.subtitle}</div>
          <p style={{ color: '#ecfdf5', fontSize: 15, lineHeight: 1.6, margin: '12px 0 0' }}>{G.intro}</p>
          {G.flow?.length > 0 && (
            <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6, marginTop: 14 }}>
              {G.flow.map((f, i) => (
                <React.Fragment key={f}>
                  {i > 0 && <ArrowRightOutlined style={{ color: '#a7f3d0', fontSize: 12 }} />}
                  <span style={{ background: '#facc15', color: '#0f172a', fontWeight: 700, fontSize: 13, borderRadius: 999, padding: '3px 12px' }}>
                    {f}
                  </span>
                </React.Fragment>
              ))}
            </div>
          )}
        </div>

        {G.sections.map((s, idx) => (
          <Card key={s.title} style={{ borderRadius: 14, marginBottom: 16 }} styles={{ body: { padding: '20px 22px' } }}>
            <h2 style={{ color: GREEN, fontSize: 20, fontWeight: 800, margin: '0 0 12px' }}>
              <span style={{ display: 'inline-block', minWidth: 30, height: 30, lineHeight: '30px', textAlign: 'center', borderRadius: '50%', background: GREEN, color: '#fff', fontSize: 15, marginRight: 10 }}>
                {idx + 1}
              </span>
              {s.title}
            </h2>

            {s.paragraphs?.map((p) => <p key={p} style={textStyle}>{p}</p>)}
            {s.quote && quoteBox(s.quote)}
            {s.after && <p style={textStyle}>{s.after}</p>}

            {s.steps?.map((st, i) => (
              <div key={st.title} style={{ marginBottom: 16 }}>
                <div style={{ fontWeight: 700, color: '#0f172a', fontSize: 15.5, marginBottom: 4 }}>{`Bước ${i + 1}. ${st.title}`}</div>
                <p style={textStyle}>{st.text}</p>
                {st.quote && quoteBox(st.quote)}
                {st.images?.length > 0 && (
                  <Image.PreviewGroup>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                      {st.images.map((img) => (
                        <Image key={img.src} src={img.src} alt={img.alt} style={{ maxWidth: '100%', border: '1px solid #e2e8f0', borderRadius: 8 }} />
                      ))}
                    </div>
                  </Image.PreviewGroup>
                )}
              </div>
            ))}

            {s.list && (
              <ol style={{ paddingLeft: 20, margin: 0 }}>
                {s.list.map((li) => <li key={li} style={{ ...textStyle, marginBottom: 8 }}>{li}</li>)}
              </ol>
            )}

            {s.commands?.map((c) => (
              <div key={c.label} style={{ marginBottom: 10 }}>
                <div style={{ fontWeight: 700, color: '#0f172a' }}>{c.label}</div>
                {quoteBox(`"${c.text}"`)}
                {c.after && <p style={textStyle}>{c.after}</p>}
              </div>
            ))}

            {s.note && <Alert type="warning" showIcon message={s.note} style={{ marginTop: 8, borderRadius: 8 }} />}
          </Card>
        ))}

        {T.support && (
          <Card style={{ borderRadius: 14, textAlign: 'center' }}>
            <p style={textStyle}>{T.support.text}</p>
            <Button type="primary" icon={<PhoneOutlined />} href={`tel:${T.support.phone}`} style={{ background: GREEN, borderColor: GREEN }}>
              {T.support.phoneLabel}
            </Button>
          </Card>
        )}
      </div>
    </div>
  );
}
